"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeById = mergeById;
function mergeById(current, incoming) {
    var mergedById = new Map();
    current.forEach(function (item) { return mergedById.set(item.id, item); });
    incoming.forEach(function (item) { return mergedById.set(item.id, item); });
    return Array.from(mergedById.values());
}
